import { render } from "./MarkdownExpandable.vue?vue&type=template&id=479460b9&scoped=true&ts=true"
import script from "./MarkdownExpandable.vue?vue&type=script&lang=ts"
export * from "./MarkdownExpandable.vue?vue&type=script&lang=ts"

import "./MarkdownExpandable.vue?vue&type=style&index=0&id=479460b9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-479460b9"]])

export default __exports__